import type { ComponentSchema } from "../../../../../schema-types";
import { SECTION_STYLE_FIELDS } from "../../_builder-constants";

export const schema: ComponentSchema = {
  type: "coupon",
  label: "Coupons",
  description: "A grid of coupon cards with discount code, title, description, expiry date, and a copy-to-clipboard button.",
  supportedPages: ["coupon"],
  variants: [
    {
      id: "v1",
      label: "Card Grid",
    },
  ],
  commonFields: [
    { key: "title", label: "Section Title", type: "string", default: "Available Coupons" },
    {
      key: "coupons",
      label: "Coupons",
      type: "array",
      itemSchema: [
        { key: "code", label: "Coupon Code", type: "string" },
        { key: "title", label: "Title", type: "string" },
        { key: "description", label: "Description", type: "text" },
        { key: "expiryDate", label: "Expiry Date", type: "string" },
        { key: "discount", label: "Discount (e.g. 20% or Free Shipping)", type: "string" },
        { key: "bgColor", label: "Badge Background Color", type: "color" },
      ],
    },
    ...SECTION_STYLE_FIELDS,
  ],
};
